import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#7A7A7A',
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    fontFamily: 'Barlow Condensed, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '30px',
          fontFamily: 'Barlow Condensed, sans-serif',
          ':hover': {
            backgroundColor: '#7A7A7A',
          },
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#000000',
          width: '30px !important',
          height: '30px !important',
          ':hover': {
            backgroundColor: '#7A7A7A',
          },
        },
      },
    },
  },
});

export default theme;
